import React from 'react';
import {View} from 'react-native';
import {KidSubformViewProps} from '../model';
// import {useStyles} from '../../../../../../shared/hooks/styles';
import {LoadableContent} from '../../../../../../shared/components/loadableContent';
import {kidSubformFields, kidSubformFieldsNames} from './constants';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {Form} from '../../../../../../shared/components/form';
import {KidSubformField} from './kidSubformField';

export default ({formValues, loading, submissionErrors, setSubmissionErrors, kidId}: KidSubformViewProps) => {
  return (
    <LoadableContent loading={loading} style={{height: '100%'}}>
      {formValues && !loading ? (
        <CustomScrollView withRefresh={false} contentInsetAdjustmentBehavior='automatic'>
          <Form onSubmit={() => {}} style={{width: `100%`}}>
            <View testID='esia-reg-card-form' style={{width: `100%`}}>
              {kidSubformFieldsNames.map((name) => {
                const config = kidSubformFields[name];
                if (!config) return null;
                return (
                  <KidSubformField
                    error={submissionErrors?.[name]?.error ?? null}
                    setSubmissionErrors={setSubmissionErrors}
                    key={name}
                    value={formValues[name]}
                    name={name}
                    kidId={kidId}
                    {...config}
                  />
                );
              })}
            </View>
          </Form>
        </CustomScrollView>
      ) : null}
    </LoadableContent>
  );
};
